const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  USDC_WETH: "0x853ee4b2a13f8a742d64c8f088be7ba2131f670d"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_WETH]: "0xbb703e95348424ff9e94fbe4fb524f6d280331b8"
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_WETH]: 1,
};

const PAIR_ADDRESS_TO_SUSHIBAR_REWARDS = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_WETH]: [true],
};

const PAIR_ADDRESS_TO_UNWRAPPED_SUSHIBAR_REWARDS = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_WETH]: ["0x831753dd7087cac61ab5644b308642cc1c33dc13"],
};

module.exports = {
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH,
  PAIR_ADDRESS_TO_SUSHIBAR_REWARDS,
  PAIR_ADDRESS_TO_UNWRAPPED_SUSHIBAR_REWARDS
};
